import { useQuery } from "@tanstack/react-query"
import type { ProjectResponse } from "@zplanem/responses"
import { ApiError, apiFetch } from "../../lib/api-client"
import { queryKeys } from "../../lib/query-keys"

export function useProject(
	propertyId: string | undefined,
	projectId: string | undefined,
) {
	return useQuery({
		queryKey:
			propertyId && projectId
				? queryKeys.project(propertyId, projectId)
				: ["properties", "__nil__", "projects", "__nil__"],
		queryFn: () =>
			apiFetch<ProjectResponse>(
				`/api/common/properties/${propertyId}/projects/${projectId}`,
			).then((res) => res.project),
		enabled: !!propertyId && !!projectId,
		retry: (failureCount, error) => {
			// 404s are terminal — invisible or nonexistent project. Surface
			// immediately instead of hammering the API.
			if (error instanceof ApiError && error.status === 404) return false
			return failureCount < 3
		},
	})
}
